import { Component, Input } from '@angular/core';
//import { Braintree } from 'braintree-angular';
import { NavController, NavParams, AlertController, LoadingController } from 'ionic-angular';
import { Http } from '@angular/http';

import {Contacts, ContactFindOptions} from 'ionic-native';

import { TasksDetailComponent } from '../tasks-detail/tasks-detail';
import { PublicPage } from '../../pages/public/public';
import { Task } from '../../providers/task';
import { User } from '../../providers/user';

declare var braintree: any;
declare const Twilio: any;

@Component({
  selector: 'tasks-comment',
  templateUrl: 'tasks-comment.html'
})
export class TasksCommentComponent {

  @Input() profile: any = {};
  @Input() payment: any;
  @Input() entry: any = {
    id: false,
    title: '',
    time: '', // h:m
    amount: '',
    image: '',
    phone: '',
    transfer: 'false',
    nights:'',
    active:'',
    link: '',
    likes: [],
    comments: [],
    days: [true, false, false, false, false, false, false] // days of week
  };
  submitted: boolean = false;
  dayInvalid: boolean = false;
  PhoneDisable: boolean = false;
  commentText:any;
  
  constructor(
    public nav: NavController,
    public navParams: NavParams,
    public task: Task,
    public user: User,
    public http: Http,
    public loadingCtrl: LoadingController,
    public alert: AlertController
  ) {
    this.payment = false;
    this.entry = this.navParams.data;

    this.profile = this.user.profile();
  }

  ionViewWillEnter() {
    // braintree auth..
    // this.http.get('http://plusclick-api.azurewebsites.net/api/client?customerID='+this.profile.uid).subscribe(data => {
    //     //this.initBraintree(data.text().replace(/['"]+/g, ''));
    //     alert(data.text().replace(/['"]+/g, ''));
    // });

  }

  initBraintree(auth:any)
  {
    var button1 = document.querySelectorAll('#pay-button1')[0];
    var button2 = document.querySelectorAll('#pay-button2')[0];
    var HttpObj = this.http;
    var Entry = this.entry;
    var Task = this.task;
    var UserProfile = this.profile;
    var loading = this.loadingCtrl.create({
        content: 'Bitte warten...'
    });
    braintree.dropin.create({
      authorization: auth,// ==null ? 'sandbox_ctfvvhft_hzgd8tw3xj7zkrmt' : auth,
      selector: '#dropin-container',
      locale: 'de_DE',
      customerId: UserProfile.uid,
        paypal: {
            flow: 'vault'
      }
    }, 
    function (createErr, instance) {
        if (createErr) {
          // An error in the create call is likely due to
          // incorrect configuration values or network issues.
          // An appropriate error will be shown in the UI.
          console.error(createErr);
          return;
        }
        button1.addEventListener('click', function () {
          instance.requestPaymentMethod(function (requestPaymentMethodErr, payload) {
            if (requestPaymentMethodErr) {
              // No payment method is available.
              // An appropriate error will be shown in the UI.
              console.error(requestPaymentMethodErr);
              return;
            }
            
            var uri = '/api/api?id='+ payload.nonce + '&planID=56jm'+ '&customerID=' + UserProfile.uid;
            console.warn('Nonce: ' + payload.nonce);
            console.warn('Uri: ' + uri);
            loading.present();
            setTimeout(() => {
              loading.dismiss();
            }, 10000);
            HttpObj.get('http://plusclick-api.azurewebsites.net/' + uri).subscribe(data => {
              console.warn("result payment: " + data.statusText);
              if(data.status == 200)
              {
                Entry.active = true;
                Task
                  .save(Entry)
                  .then(() => {
                    console.info(`task ${Entry.title} saved`);
                    loading.dismiss();
                  }).catch((e) => { console.error(e); });
              }
            });
        });
        });
        button2.addEventListener('click', function () {
          instance.requestPaymentMethod(function (requestPaymentMethodErr, payload) {
            if (requestPaymentMethodErr) {
              // No payment method is available.
              // An appropriate error will be shown in the UI.
              console.error(requestPaymentMethodErr);
              return;
            }
            
            var uri = '/api/api?id='+ payload.nonce + '&planID=5r7g'+ '&customerID=' + UserProfile.uid;
            console.warn('Nonce: ' + payload.nonce);
            console.warn('Uri: ' + uri);
            loading.present();
            setTimeout(() => {
              loading.dismiss();
            }, 10000);
            HttpObj.get('http://plusclick-api.azurewebsites.net/' + uri).subscribe(data => {
              console.warn("result payment: " + data.statusText);
              if(data.status == 200)
              {
                Entry.active = true;
                Task
                  .save(Entry)
                  .then(() => {
                    console.info(`task ${Entry.title} saved`);
                    loading.dismiss();
                  }).catch((e) => { console.error(e); });
              }
            });
        });
        });
    });
  }


  today() : String{
    return new Date().toISOString();
  }

  onLike(event: Event, entry?: any) {
    event.preventDefault();
    console.info(JSON.stringify(this.user.profile()));
    if(entry.likes == undefined)
      entry.likes = [];
    entry.likes.indexOf(this.user.profile().email) === -1 ? entry.likes.push(this.user.profile().email) : entry.likes.pop(this.user.profile().email);
    this.task
        .save(entry)
        .then(() => {
          console.info(`task ${entry.title} saved`);
        }).catch((e) => { console.error(e); });
  }

  onDetail(data?: any) 
  {
    this.nav.push(TasksDetailComponent, data);
  }

  saveComment()
  {

    if(this.entry.comments == undefined)
    {
      this.entry.comments = []
    }
    this.entry.comments.push({id:'', image:this.user.profile().photoURL, name:this.user.profile().displayName, createdAt:this.today(), createdby:this.user.profile().email, text: this.commentText});

    this.task
        .save(this.entry)
        .then(() => {
          console.info(`task ${this.entry.title} saved`);
          this.commentText = '';
        }).catch((e) => { console.error(e); });
  }

  numberOfLikes(likes)
  {
    if(likes != undefined)
    {
      //alert(JSON.stringify(likes));
      try
      {
        return likes.length;
      }
      catch(dd)
      {
        alert(dd); 
        return 0;
      }
    }
  }

  timeSince(time: any) {
    //console.info(time);
    if(time != undefined)
    {
      switch (typeof time) {
        case 'number':
          break;
        case 'string':
          time = +new Date(time);
          break;
        case 'object':
          if (time.constructor === Date) time = time.getTime();
          break;
        default:
          time = +new Date();
      }
      var time_formats = [
        [60, 'seconds', 1], // 60
        [120, '1 minute ago', '1 minute from now'], // 60*2
        [3600, 'minutes', 60], // 60*60, 60
        [7200, '1 hour ago', '1 hour from now'], // 60*60*2
        [86400, 'hours', 3600], // 60*60*24, 60*60
        [172800, 'Yesterday', 'Tomorrow'], // 60*60*24*2
        [604800, 'days', 86400], // 60*60*24*7, 60*60*24
        [1209600, 'Last week', 'Next week'], // 60*60*24*7*4*2
        [2419200, 'weeks', 604800], // 60*60*24*7*4, 60*60*24*7
        [4838400, 'Last month', 'Next month'], // 60*60*24*7*4*2
        [29030400, 'months', 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
        [58060800, 'Last year', 'Next year'], // 60*60*24*7*4*12*2
        [2903040000, 'years', 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
        [5806080000, 'Last century', 'Next century'], // 60*60*24*7*4*12*100*2
        [58060800000, 'centuries', 2903040000] // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
      ];
      var seconds = (+new Date() - time) / 1000,
        token = 'ago',
        list_choice = 1;

      if (seconds == 0) {
        return 'Just now'
      }
      if (seconds < 0) {
        seconds = Math.abs(seconds);
        token = 'from now';
        list_choice = 2;
      }
      var i = 0,
        format;
      while (format = time_formats[i++])
        if (seconds < format[0]) {
          if (typeof format[2] == 'string')
            return format[list_choice];
          else
            return Math.floor(seconds / format[2]) + ' ' + format[1] + ' ' + token;
        }
      return time;
    }
    else
    {
      return 'NAN';
    }
}

  numberOfComments(comments: any)
  {
    if(comments != undefined)
    {
      //alert(JSON.stringify(comments));
      try
      {
        return comments.length;
      }
      catch(dd)
      {
        alert(dd); 
        return 0;
      }
    }
    else
    {
      return 0;
    }
  }

  onCopy(event: Event, data?: any) {
    event.preventDefault();
    event.stopPropagation();
  }

  parseDate(str) {
    if(str == undefined)
      return;
    var mdy = str.split('/');
    return new Date(mdy[2], mdy[1], mdy[0]);
  }

  daydiff(first, second) {
    debugger;
    return Math.round((second-first)/(1000*60*60*24));
  }
  
  todayFormat()
  {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth()+1; //January is 0!

    var yyyy = today.getFullYear();
    // if(dd<10){
    //     dd='0'+dd;
    // } 
    // if(mm<10){
    //     mm='0'+mm;
    // } 
    return dd+'/'+mm+'/'+yyyy;
  }

  onBuyMonthly(event: Event, data?: any) {
    event.preventDefault();
    event.stopPropagation();
    data.buyModel = "monthly1";
    data.active = true;
    data.BoughtAt = this.todayFormat();//new Date().toLocaleString();
    this.task
      .save(data)
      .then(() => {
        console.info(`task ${data.title} saved`);
      }).catch((e) => { console.error(e); });
    this.user.updateConversion();
  }

  onBuyYearly(event: Event, data?: any) {
    event.preventDefault();
    event.stopPropagation();
    data.buyModel = "yearly1";
    data.active = true;
    debugger;
    data.BoughtAt = this.todayFormat();//new Date().toLocaleString();
    this.task
      .save(data)
      .then(() => {
        console.info(`task ${data.title} saved`);
      }).catch((e) => { console.error(e); });
    debugger;
    this.user.updateConversion();
  }

  onSendSMS(event: Event, data?: any) {
    event.preventDefault();
    event.stopPropagation();
    debugger; 
    this.updatePhoneNumber(this.entry.phone, data);
    this.http.get('https://us-central1-payday-4dbd5.cloudfunctions.net/addMessage?phone=' + this.entry.phone + '&code=' + this.entry.code + '&sec=sdkljfgskjahdfgksdHGF22LKDSNDASlkjHadwuuwbgCSAEJDNSLEFN32874937JKEBDNSMDB&tiny='+this.entry.tinyurl).subscribe(data => {
        //this.initBraintree(data.text().replace(/['"]+/g, ''));
    });

  }
  public updatePhoneNumber(PhoneNumber:any, data?: any) {
    if (PhoneNumber != "") {
      //this.user.updatePhone(PhoneNumber);
      data.PhoneNumber = PhoneNumber;
      this.task
        .save(data)
        .then(() => {
          console.info(`task ${data.title} saved`);
          this.PhoneDisable = true;
        }).catch((e) => { console.error(e); });
    }
  }

  onOpenPublic(event: Event, data?: any) {
    event.preventDefault();
    event.stopPropagation();
    //this.nav.push(PublicPage, data);
    var win = window.open(data.tinyurl, '_blank');
    win.focus();
  }

  formatDate(dateString)
  {
    var monthNames = [
      "January", "February", "March",
      "April", "May", "June", "July",
      "August", "September", "October",
      "November", "December"
    ];

    var date = new Date(dateString);
    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();

    return day + ' ' + monthNames[monthIndex] + ' ' + year;
  }

  taskUpdate(form) {
    this.submitted = true;
    if (form.valid && !this.dayInvalid) {
      this.task
        .save(this.entry)
        .then(() => {
          console.info(`task ${this.entry.title} saved`);
          this.nav.pop(); //back to listing
        }).catch((e) => { console.error(e); });
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/tasks-comment/tasks-comment.ts